<template>
  <div class="but_shop_box flex" v-loading.fullscreen.lock="fullscreenLoading" v-if="placard.car_list.length">
    <!-- {{ content }} -->
    <!-- v-if="placard.car_list.length != 0" -->
    <div class="shop_length">
      <p class="shop_length_title" @click.stop="shopFn">
        已选-资源列表: {{ placard.car_list.length }}
      </p>
      <div class="shop_particulars_box" v-show="shopShow">
        <div class="shop_particulars_ct_box flex">
          <p>已选资源 {{ placard.car_list.length }}个</p>
          <p>总金额:￥{{ total_money }}元</p>
        </div>
        <!-- <img :src=`../${img}` alt=""> -->
        <ul class="shop_list">
          <li v-for="(item, index) in placard.car_list" :key="index">

            <div class="name">

              <el-tooltip class="item" effect="dark" :content="item.title" placement="top">
                <span>{{ item.title }}</span>
              </el-tooltip>
            </div>
            <div class="line"></div>
            <div class="price_box">
              <div>投放价格：￥{{ (item.member_guanggao_price[item.type]) * item.cycle }}元</div>
              <div>设计价格：￥{{ item.design_price }}元</div>
            </div>
            <i class="el-icon-delete-solid" @click.stop="deleteFn(item)"></i>


          </li>
        </ul>
        <div class="flex" style="justify-content: flex-end">
          <button class="close" @click.stop="shopShow = false">关闭</button>
        </div>
      </div>
    </div>
    <!-- v-if="placard.car_list.length != 0" -->
    <div class="price_box flex">
      <p class="money" style="margin-right: 20px;">
        账户余额: <span>￥{{ $user_info.guanggao_money }}</span>元
      </p>
      <p class="price">
        总价: <span>￥{{ total_money }}</span>元
      </p>

      <button v-if="$route.name == 'placard_fill'" class=" preview" @click.stop="subFn1">
        预览文章并发布
      </button>
      <button v-if="$route.name == 'placard_manuscript_preview'" class="sub" @click.stop="subFn2">
        确认下单
      </button>
      <!-- <button v-if="$route.name == 'ManuscriptDetails'" class="sub" @click.stop="subFn3">
        立即支付
      </button> -->
    </div>
    <!-- <div class="shop_length" v-if="placard.car_list.length == 0">

    </div> -->
    <!-- 遮罩层 -->
    <div class="MaskLayer" @click="shopShow = !shopShow" v-show="shopShow"></div>
    <sensitivityPopup @close="close" :visible="popupVisible" :content="popupContent" :type="2"/>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import sensitivityPopup from '@/components/sensitivityPopup.vue'
import {fill_title_rules} from '@/util/fill_title_rules'

export default {
  name: '',
  computed: {
    ...mapState(['placard']),
    ...mapMutations('placard', ['DELETE_LIST', 'RESET_FILL_FORM', 'SET_ORDER_STATUS']),
    total_money: function () {
      var n = 0;
      this.placard.car_list.forEach((item, index) => {
        if (item.check) {
          n += (item.member_guanggao_price[item.type] * item.cycle) + parseInt(item.design_price)
        } else {
          n += item.member_guanggao_price[item.type] * item.cycle
        }
      })
      return n.toFixed(2)
    },
  },
  components: {
    sensitivityPopup
  },
  data() {
    return {
      shopShow: false,
      fullscreenLoading: false,
      popupVisible: false,
      popupContent: [],
      cycle_list: ['天', '周', '月', '次', '期']
    }
  },
  methods: {
    // 更新用户信息
    setUserInfo() {
      this.curlGet('/api/user/info').then((res) => {
        if (res.data.code) {
          this.$util.setLocalStorage('user_info', res.data.data) // 写入local storage
          this.$user_info = res.data.data
          console.log(this.$user_info);
        }
      })
    },
    shopFn() {
      this.shopShow = true
    },
    // 预览
    subFn1() {
      // 效验标题状态
      const titleStatus = fill_title_rules(this.placard.fill_form.title)
      if (!titleStatus) {
        return
      }
      if (this.placard.fill_form.content == '') {
        return this.$message({
          type: 'warning',
          message: '内容不能为空',
        })
      }
      console.log(this.placard.fill_form)
      this.verifyTest()
    },
    subFn2() {
      if (this.$user_info.guanggao_money - this.total_money < 0) {
        // this.$message({
        // 	type: 'warning',
        // 	message: '余额不足,请充值',
        // })
        this.$alert('<p style="color: #333;font-size: 1.1rem;">余额不足,<a style="color: #108cdd;font-weight: bold;text-decoration: none;" href="https://www.qixuantong.com/user/refill" target="_blank">点击跳转至充值</a></p><p>充值完成后可返回此页面继续提交订单</p>', '提示', {
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          confirmButtonText: '确认充值完成'
        }).then(res => {
          this.setUserInfo()
        })
      } else {
        this.fullscreenLoading = true
        // console.log('this.placard.fill_form', this.placard.fill_form)

        let data = {}
        data.info_ids = []
        this.placard.car_list.forEach((item, index) => {
          console.log(item);
          data.info_ids.push({
            id: item.id,
            type: item.type,
            design_price: item.check ? item.design_price : 0,
            cycle: item.cycle,
          })
        })

        data.category_id = this.placard.car_list[0].category_id

        data.info_ids = JSON.stringify(data.info_ids)
        data.title = this.placard.fill_form.title
        data.content = this.placard.fill_form.content
        data.file = this.placard.fill_form.file

        if (this.placard.fill_form.business_license_list.length !== 0) {
          data.business_license = this.placard.fill_form.business_license_list[0].url
        }
        if (this.placard.fill_form.shangbiao_zhengshu_list.length !== 0) {
          data.shangbiao_zhengshu = this.placard.fill_form.shangbiao_zhengshu_list[0].url
        }
        data.qita_zizhi = ''
        if (this.placard.fill_form.qita_zizhi_list.length !== 0) {
          this.placard.fill_form.qita_zizhi_list.forEach((item, index) => {
            if (data.qita_zizhi === '') {
              data.qita_zizhi = item.url
            } else {
              data.qita_zizhi = data.qita_zizhi + '\n' + item.url
            }
          })
        }
        // console.log('data', data)

        this.curlPost('/api/users/guanggao_order/save', data).then((res) => {
          if (res.data.code) {
            // 更新用户数据
            this.setUserInfo()
            this.$message({
              type: 'success',
              message: '支付成功',
            })
            this.$store.commit('SET_ORDER_DATA', {
              index: 'category_id',
              value: data.category_id
            })
            this.$store.state.menu_active = '/placard_user/placard_order'
            this.$store.commit('RESET_FILL_FORM')
            this.$store.commit('SET_ORDER_STATUS', 0)
            this.$router.push('/placard_user/placard_order')
          } else {
            this.$message({
              type: 'warning',
              message: res.data.msg,
            })
          }
        })
        this.fullscreenLoading = false


      }
    },
    // 删除
    deleteFn(item) {
      // console.log(item)
      this.$store.commit('DELETE_LIST', item.id)
    },
    // 关闭敏感词弹窗
    close() {
      this.popupVisible = false;
    },
    // 效验文章是否有敏感字
    verifyTest() {
      this.fullscreenLoading = true
      this.popupContent = []
      if (this.placard.fill_form.content) {
        this.curlGet('/api/index/website').then(res => {
          res.data.data.sensitive_word.forEach((item, index) => {
            if (this.placard.fill_form.content.indexOf(item) > 0) {
              this.fullscreenLoading = false
              this.popupContent.push(item)
              return this.popupVisible = true
            }
          })
        })
      }
      setTimeout(() => {
        this.fullscreenLoading = false
        if (this.popupContent.length == 0) {
          this.$router.push('/placard_user/placard_manuscript_preview')
        }
      }, 800)
    },
  },

}
</script>

<style lang=scss scoped>
@use '@/scss/fill_set'
</style>